import { Component, OnInit, Input } from "@angular/core";
import { Segment } from "../../../model/segment";
import { Router } from "@angular/router";
import { RouteBooking } from "../../../model/routebooking";
import { SessionService } from "../../../session.service";

@Component({
  selector: "app-booking-detail",
  templateUrl: "./booking-detail.component.html",
  styleUrls: ["./booking-detail.component.css"],
})
export class BookingDetailComponent implements OnInit {
  @Input() segments: Segment[];
  @Input() booking: RouteBooking = {
    escala: [
      {
        Ruta: {
          EstacionInicialNombre: "",
          FechaSalida: "",
          HoraSalida: "",
          EstacionFinalNombre: "",
          HoraLlegada: "",
        },
      },
    ],
    pp: false,
    persons: [],
    id: 0,
    status: 0,
    seats: [],
    etickets_email: "",
    etickets_email2: "",
    etickets_phone: "",
    etickets_emergency_contact: "",
    etickets_contact_firstName: "",
    etickets_contact_lastName: "",
    observaciones: "",
    classID: 0,
    routeID: 0,
    travels: [],
    round: false,
    dateDisabledDatePicker: [],
    booking_code: "",
    booking_totalamount: "",
    booking_tax: "",
    booking_discount: "",
    parseJSONObject: function (object: Object): void {
      throw new Error("Function not implemented.");
    },
    setupFromSession: function (session: SessionService): void {
      throw new Error("Function not implemented.");
    },
    formaPago: undefined,
  };
  @Input() Bruto = "0";
  @Input() discount = "0";
  @Input() Total = "0";
  @Input() PagoParcial = "0";
  @Input() TotalFinal = "0";
  @Input() labelClass = "6";
  private departure: string;
  private arrival: string;
  private dateDif: string;

  constructor(private router: Router) {}

  ngOnInit() {}

  public getTotalPassengers() {
    return this.booking.persons.length;
  }
  public getDateTable(fechaStr: string): String {
    return this.getDate(false, fechaStr);
  }
  private getDate(with_weekday: boolean = true, date: string): string {
    //let d:Date = new Date(this.date);
    let d: Date = this.mkDate(date);
    var s: string = "";
    if (with_weekday) {
      s += this.getWeekday(d.getDay(), false, date) + " ";
    }
    s += d.getDate().toString().padStart(2,"0") + "/" + (d.getMonth() + 1).toString().padStart(2,"0") + "/" + d.getFullYear();
    return s;
  }
  private mkDate(s: string): Date {
    var mps: string[] = s.split(" ");
    let now: Date = new Date();
    if (mps.length == 1) {
      mps.push("00:00:01");
    }
    let dps: string[] = mps[0].split("-");
    let tps: string[] = mps[1].split(":");

    let year: number = dps.length >= 1 ? parseInt(dps[0]) : now.getFullYear();
    let month: number = dps.length >= 2 ? parseInt(dps[1]) - 1 : now.getMonth();
    let day: number = dps.length >= 3 ? parseInt(dps[2]) : now.getDate();

    let hour: number = tps.length >= 1 ? parseInt(tps[0]) : now.getHours();
    let minute: number = tps.length >= 2 ? parseInt(tps[1]) : now.getMinutes();
    let second: number = tps.length >= 3 ? parseInt(tps[2]) : now.getSeconds();

    let dd: Date = new Date(year, month, day, hour, minute, second);
    return dd;
  }
  private getWeekday(
    n: number = -1,
    full: boolean = true,
    date: string
  ): string {
    if (n == -1) {
      //let d:Date = new Date(this.date);
      let d: Date = this.mkDate(date);
      return this.getWeekday(d.getDay(), full, date);
    }
    if (!full) {
      switch (n) {
        case 0:
          return "Dom";
        case 1:
          return "Lun";
        case 2:
          return "Mar";
        case 3:
          return "Mié";
        case 4:
          return "Jue";
        case 5:
          return "Vie";
        case 6:
          return "Sáb";
      }
    } else {
      switch (n) {
        case 0:
          return "Domingo";
        case 1:
          return "Lunes";
        case 2:
          return "Martes";
        case 3:
          return "Miércoles";
        case 4:
          return "Jueves";
        case 5:
          return "Viernes";
        case 6:
          return "Sábado";
      }
    }
  }

  private getDepartureTime(): string {
    return this.departure;
  }
  private getArrivalTime(): string {
    return this.arrival;
  }
  private getDepartureDateTime(): string {
    return this.dateDif + " " + this.departure;
  }
  private getArrivalDateTime(): string {
    return this.dateDif + " " + this.arrival;
  }

  public getDuration(date: string, departure: string, arrival: string): string {
    this.departure = departure;
    this.arrival = arrival;
    this.dateDif = date;

    var dd = this.mkDate(this.getDepartureDateTime());
    var ad = this.mkDate(this.getArrivalDateTime());

    if (this.getArrivalDateTime() < this.getDepartureDateTime()) {
      dd = this.mkDate(this.getArrivalDateTime());
      ad = this.mkDate(this.getDepartureDateTime());
    }

    if (ad.getHours() != 0 && dd.getHours() != 0) {
      var dif: number = ad.getTime() - dd.getTime();

      var s: number = 1000;
      var m: number = s * 60;
      var h: number = m * 60;
      var hrs: number = Math.ceil(dif / h) - 1;
      dif = dif % h;
      var mins: number = Math.ceil(dif / m);

      var hrss: string = hrs < 10 ? "0" + hrs : "" + hrs;
      var minss: string = mins < 10 ? "0" + mins : "" + mins;

      return hrss + ":" + minss;
    }

    if (ad.getHours() == 0 || dd.getHours() == 0) {
      var dif: number = ad.getTime() - dd.getTime();

      var s: number = 1000;
      var m: number = s * 60;
      var h: number = m * 60;
      var hrs: number = Math.ceil(dif / h);
      dif = dif % h;
      var mins: number = Math.ceil(dif / m);
      hrs = 24 - hrs;
      mins = 60 - mins;
      var hrss: string = hrs < 10 ? "0" + hrs : "" + hrs;
      var minss: string = mins < 10 ? "0" + mins : "" + mins;

      return hrss + ":" + minss;
    }
  }
}
